import React from 'react';
import { useField } from 'formik';
import {
  FormControl,
  FormHelperText,
  TextField,
  Theme,
} from '@material-ui/core';
import styled from '@emotion/styled';
import { ICustomTheme } from 'interfaces';

export const Control = styled(FormControl)<{
  theme: Theme;
}>`
  label {
    font-size: 1.4rem;
    margin-bottom: 100px;
  }
  input {
    font-size: 1.6rem;
  }
`;
type Props = {
  helperText?: string;
  label: string;
  name: string;
  type: string;
  variant?: 'standard' | 'outlined' | 'filled' | undefined;
};

export const StyledTextField = styled(TextField)<{
  theme: ICustomTheme;
}>(({ theme }) => ({
  // input label when focused
  '& label.Mui-focused': {
    color: theme.colors.paletteFromBO.main,
  },
  // focused color for input with variant='standard'
  '& .MuiInput-underline:after': {
    borderBottomColor: theme.colors.paletteFromBO.main,
  },
  // focused color for input with variant='filled'
  '& .MuiFilledInput-underline:after': {
    borderBottomColor: theme.colors.paletteFromBO.main,
  },
  // focused color for input with variant='outlined'
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: theme.colors.paletteFromBO.main,
    },
  },
}));

export const InputField = (props: Props) => {
  const [field] = useField(props);
  const { label, type, helperText, variant } = props;
  return (
    <Control>
      <StyledTextField
        id={field.name}
        type={type}
        variant={variant}
        label={label}
        aria-describedby={field.name}
        {...field}
      />
      {helperText && (
        <FormHelperText id={field.name}>{helperText}</FormHelperText>
      )}
    </Control>
  );
};
InputField.defaultProps = {
  required: false,
};

export default InputField;
